import { PropsWithChildren } from 'react'
import styles from './PropositionCard.module.scss'
import { Button, Shape, THEMES } from '@boltenergy-be/design-system'
import { PropositionCardProps } from './types'
import PriceDisplay from './price-display/PriceDisplay'
import Tag from 'components/tag/Tag'
import { useTranslation } from 'next-i18next/pages'
import useSelectInputGroup from 'hooks/useSelectInputGroup'
import { InputGroupKeys } from 'store/customer/enums'
import classNames from 'classnames'
import EnforcePlentyPropositionBanner from 'features/simulation/components/enforce-plenty-proposition-banner/EnforcePlentyPropositionBanner'

const PropositionCard = ({
  title,
  tag,
  children,
  icon,
  isSingleProposition,
  primaryAction,
  secondaryAction,
  ternaryAction,
  variant = 'default',
  showPlentyModal,
  ...priceProps
}: PropsWithChildren<PropositionCardProps>) => {
  // Redux
  const { isCompany } = useSelectInputGroup(InputGroupKeys.PERSONAL_DATA)

  // i18n
  const { t } = useTranslation(['simulation', 'common'])
  const isCompact = variant !== 'default'
  const isPlentyVariant = variant === 'plenty-single' || variant === 'plenty-multiple'

  return (
    <div data-compact={isCompact} data-enforce-plenty={isPlentyVariant} className={styles.proposition}>
      {variant === 'plenty-single' && <Shape color="on-light" shape="s1" theme={THEMES.PLENTY} className={styles.shape} />}

      {tag && !isPlentyVariant && <Tag className={styles.tag}>{tag}</Tag>}

      <header className={styles.header}>
        <strong className={classNames('h4 serif', styles.product)}>{title}</strong>

        <PriceDisplay
          label={`${t('common:perMonth')} (${isCompany ? t('common:exclVat') : t('common:inclVat')})`}
          className={styles.price}
          twoLines={!isCompact}
          {...priceProps}
        />
      </header>

      {!!children && children}

      {variant === 'plenty-single' && <EnforcePlentyPropositionBanner position="inside" {...{ showPlentyModal }} />}

      <Button type="button" isFullwidth onClick={primaryAction.onClick} className={styles.submit}>
        {primaryAction.label}
      </Button>

      <div className={styles['drawer-buttons']}>
        <Button type="button" representation="link" onClick={secondaryAction.onClick} size="small">
          {secondaryAction.label}
        </Button>

        <Button type="button" representation="link" onClick={ternaryAction.onClick} size="small">
          {ternaryAction.label}
        </Button>
      </div>
    </div>
  )
}

export default PropositionCard
